import Loadable from 'react-loadable';

export const ChecklistLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "checklist" */ './index'),
  loading: () => null,
});
